import { fabric } from 'fabric';
import { type IPoint } from 'fabric/fabric-impl';
import type Canvas from '../objects/Canvas';

// Brush that draws with a width that is independent of zoom.
class ConstantWidthBrush extends fabric.PencilBrush {
  constructor(
    public canvas: Canvas,
    public pathType = 'pen',
    public defaultWidth = 15
  ) {
    super(canvas);
  }

  // Measure the zoom at this point and set the width.
  _prepareForDrawing(pointer: IPoint) {
    this.width = this.defaultWidth / this.canvas.getZoom();

    // @ts-expect-error private fabric method
    super._prepareForDrawing(pointer);
  }

  createPath(pathData: string) {
    const path = super.createPath(pathData);

    // @ts-expect-error private fabric property
    path.pathType = this.pathType;

    this.canvas.controller.undoManager.completeUndoGroup();

    return path;
  }
}

export default ConstantWidthBrush;
